// 在组件加载前解析画册，避免首页无 ID 时详情和购物车读取 undefined。
export function resolveAlbumRoute(route, hostname, fetchAlbum) {
  var query = route.query || {};
  var id = query.id === undefined || query.id === null ? '' : query.id;
  var params = {action: 'resolve_album', id: id, host: hostname, path: route.path};
  if (route.path === '/detail1') params.goods_id = query.goods_id;
  return fetchAlbum(params).then(function(response) {
    var data = response.data;
    if (data && Number(data.sta) === 200 && data.res && data.res.standalone === true && (route.path === '/detail1' || route.path === '/fangandetail') && id === '') {
      return {standalone: true, path: route.path, query: query, hash: route.hash};
    }
    if (!data || Number(data.sta) !== 200 || !data.res || !/^[1-9][0-9]*$/.test(String(data.res.id))) {
      throw new Error((data && data.msg) || '无法确定当前画册');
    }
    return {
      path: route.path,
      query: Object.assign({}, query, {id: String(data.res.id)}),
      hash: route.hash,
      replace: true
    };
  });
}



// WEBPACK FOOTER //
// ./src/utils/album-entry.js